import React from 'react';
import { Box, Link as ChakraLink } from '@chakra-ui/react';

/**
 * Full width banner rendered as an image that links out to an external destination.
 * Pass `mobileSrc` when the design has a dedicated portrait artwork, otherwise the
 * desktop artwork scales down on its own.
 */
export function BannerLink({ href, alt, desktopSrc, mobileSrc }) {
  const hasMobileArtwork = Boolean(mobileSrc);

  return (
    <ChakraLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      display="block"
      width="100%"
      borderRadius="16px"
      overflow="hidden"
      _hover={{ opacity: 0.9 }}
      transition="opacity 0.2s ease-in-out">
      {hasMobileArtwork && (
        <Box as="img" src={mobileSrc} alt={alt} display={{ base: 'block', sm: 'none' }} width="100%" height="auto" />
      )}
      <Box
        as="img"
        src={desktopSrc}
        alt={alt}
        display={hasMobileArtwork ? { base: 'none', sm: 'block' } : 'block'}
        width="100%"
        height="auto"
      />
    </ChakraLink>
  );
}
